import * as React from "react";
import { MenuEntry } from "../../../../../datatypes/businessaccounts/BusinessAccount";
import { trackLogout } from "../../../../../utils/AccountFlyoutTrackingUtil";
import { LogoutManualAction } from "../../../../../uidispatcherapi/SessionStore";
import { FormattedMessage } from "react-intl";
import CountryUtil from "../../../../../uidispatcherapi/CountryUtil";

type Props = {
    activeAccountId: string;
    tierLevel: string | undefined;
};

export function AccountFlyoutBottomLinks(props: Props) {
    const bottomLinks: Array<MenuEntry> | null = CountryUtil.getFlyoutConfig().bottomLinks || null;

    function handleLogout(event: any | null | undefined, tierLevel: string | undefined): void {
        if (event) {
            event.preventDefault();
            trackLogout(tierLevel || "");
        }
        if (typeof LogoutManualAction === "function") {
            LogoutManualAction();
        }
    }

    function renderMenuEntries(menuEntries: Array<MenuEntry>, activeContext: string) {
        return menuEntries.map((item, index) => {
            const url = item.url.replace("$account-id", activeContext);
            return (
                <div key={"bottom-link" + index} className="bottom-link">
                    <a className="account-label menu-entry" href={url}>
                        {item.text}
                    </a>
                </div>
            );
        });
    }

    return (
        <React.Fragment>
            {bottomLinks && renderMenuEntries(bottomLinks, props.activeAccountId)}
            <div>
                <div className="account-label idam-logout" onClick={(e) => handleLogout(e, props.tierLevel)}>
                    <FormattedMessage id={"EX_LOGOUT_IN_HEADER"} />
                </div>
            </div>
        </React.Fragment>
    );
}
